
import http from "@/services/http";

const get = (params) => http.get(`hubspot-search`, { params: params })

export default {
  get
}
